import { createSignal, onMount, Show } from 'solid-js';

// "Add to home screen" prompt, shown ONCE on a phone's first visit (not when
// already installed/standalone, not on desktop, and not after the user dismisses
// it). Android fires beforeinstallprompt so we can trigger the native installer;
// iOS Safari has no such event, so we show the manual Share -> Add steps.

const standalone = () =>
  window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
const ua = navigator.userAgent || '';
const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
const isAndroid = /Android/.test(ua);
const isMobile = isIOS || isAndroid;

export default function InstallPrompt() {
  const [show, setShow] = createSignal(false);
  const [ios, setIos] = createSignal(false);
  let deferred = null;

  function close(remember) {
    setShow(false);
    if (remember) { try { localStorage.setItem('installDismissed', '1'); } catch {} }
  }

  onMount(() => {
    if (standalone() || !isMobile) return;
    try { if (localStorage.getItem('installDismissed')) return; } catch {}

    // Android / Chromium: capture the install event and offer a real button.
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      deferred = e;
      setIos(false);
      setShow(true);
    });
    // iOS Safari: no event — show the manual instructions shortly after load.
    if (isIOS) {
      setIos(true);
      setTimeout(() => { if (!standalone()) setShow(true); }, 1200);
    }
  });

  async function install() {
    if (!deferred) return;
    deferred.prompt();
    try { await deferred.userChoice; } catch {}
    deferred = null;
    close(true);
  }

  return (
    <Show when={show()}>
      <div class="pwa-install">
        <img class="pwa-install-ic" src="/icon-192.png" alt="" width="46" height="46" />
        <div class="pwa-install-body">
          <div class="pwa-install-title">Pasang Payroll Metalindo</div>
          <Show when={ios()} fallback={
            <div class="pwa-install-sub">Tambahkan ke layar utama — akses cepat seperti aplikasi.</div>
          }>
            <div class="pwa-install-sub">Ketuk <b>Bagikan</b> lalu <b>Tambah ke Layar Utama</b>.</div>
          </Show>
        </div>
        <div class="pwa-install-act">
          <Show when={!ios()}>
            <button class="btn primary" onClick={install}>Pasang</button>
          </Show>
          <button class="btn ghost" onClick={() => close(true)}>Nanti</button>
        </div>
      </div>
    </Show>
  );
}
